import createAction from '../../../utils/redux-helpers/createAction';

const handler = (state, { header }) =>
  state.set('currentDeliveryZoneHeader', header);

export const setDeliveryZoneHeader = createAction({
  action: ['setDeliveryZoneHeader', 'header'],
  handler,
});
